// Мутации журнала диспутов (создание, смена причины, закрытие) показывают свой текст ошибки.
// Загрузки списка и истории клиента под исключение не попадают — им нужен общий алерт.
// Загрузку кандидатов в виновники окно спора о выплате тоже объясняет само.
const DISPUTE_MUTATION_URL =
  /\/internal\/dispute(\/(deposit|payout))?((\/\d+\/(reason|resolve-success(\/preview)?|resolve-reject))|(\/[0-9a-fA-F-]{36}\/culprit-candidates))?$/

export const isDisputeMutationUrl = (url?: string): boolean => DISPUTE_MUTATION_URL.test(url ?? '')
